export const QUOTE_RESPONSE = "We will get with touch with you soon. Thanks for showing interest in our product.";
export const ERROR_MESSAGE = "Something Went wrong, please try again later.";
export const SUPPORT = "SUPPORT";